import Backbone from 'backbone';
import mediaInsight from 'models/mediaInsight';

class mediaInsights extends Backbone.Collection {
    model = mediaInsight;
    url() { return `/api/reader/${this.reader_configuration_id}/reader_insights/v1`; }
}

export default mediaInsights;
